import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type TextareaProps = {
  id?: string;
  value: string;
  name?: string;
  rows?: number;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  style?: React.CSSProperties;
};
function Textarea(t0) {
  const $ = _c(14);
  const {
    id,
    name,
    value,
    rows: t1,
    placeholder: t2,
    disabled: t3,
    hasError: t4,
    onChange,
    className: t5,
    style
  } = t0;
  const rows = t1 === undefined ? 3 : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const disabled = t3 === undefined ? false : t3;
  const hasError = t4 === undefined ? false : t4;
  const className = t5 === undefined ? "" : t5;
  const t6 = hasError ? "border-red-300" : "border-gray-300";
  let t7;
  if ($[0] !== className || $[1] !== t6) {
    t7 = cx("shadow-2xs block w-full rounded-4xl border px-5 py-3 text-blue", "placeholder:text-gray-500", "disabled:cursor-not-allowed disabled:text-gray-500", t6, className);
    $[0] = className;
    $[1] = t6;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== disabled || $[4] !== hasError || $[5] !== id || $[6] !== name || $[7] !== onChange || $[8] !== placeholder || $[9] !== rows || $[10] !== style || $[11] !== t7 || $[12] !== value) {
    t8 = <textarea id={id} name={name} rows={rows} className={t7} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} aria-invalid={hasError} style={style} />;
    $[3] = disabled;
    $[4] = hasError;
    $[5] = id;
    $[6] = name;
    $[7] = onChange;
    $[8] = placeholder;
    $[9] = rows;
    $[10] = style;
    $[11] = t7;
    $[12] = value;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
export default Textarea;